"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInputLabel = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../../theme/global/typography");
exports.MuiInputLabel = {
    root: {
        lineHeight: 1,
        color: palette_1.palette.grey[600],
        '&$focused': {
            color: palette_1.palette.primary.main,
        },
        '&$error': {
            color: palette_1.palette.error.main,
        },
        '&$disabled': {
            color: palette_1.palette.grey[400],
        },
    },
    outlined: {
        transform: "translate(16px, 16px) scale(1)",
        '&$shrink': {
            '&$marginDense': {
                transform: 'translate(14px, -6px) scale(0.85)',
            },
        },
    },
    shrink: {
        //Default styling changes font size to 75% scale, i.e. ${rem(12)}
        lineHeight: 1,
        letterSpacing: 0.4,
        fontWeight: typography_1.typography.fontWeightMedium,
    },
    marginDense: __assign(__assign({}, typography_1.typography.body2), { lineHeight: 1.2 }),
};
